import { createAction, props } from '@ngrx/store';
import { Charger } from '../../chargers/models/charger.interface';

export const loadChargers = createAction('[Chargers/API] Load Chargers');

export const loadedChargers = createAction('[Chargers/API] Loaded Chargers Success', props<{ chargers: Charger[] }>());
